import { observer } from 'mobx-react-lite';

import { ArticleOnboardingIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { OnboardingPopover } from '@gem/ui-kit';

import { OnboardingType } from 'APP/constants/onboarding';
import { useOnboardingManager } from 'APP/main/hooks/onboardingManager/useOnboardingManager';

const FirstArticleOnboarding = ({ reference }) => {
  const { t } = useTranslation();
  const presenter = useOnboardingManager(OnboardingType.CreateFirstArticle);

  if (!presenter.isNeedToShow) {
    return null;
  }

  return (
    <OnboardingPopover
      title={t('channel_article_first_article_title')}
      description={t('channel_article_first_article')}
      Icon={ArticleOnboardingIcon}
      handleClose={presenter.handleClose}
      reference={reference}
      isOpened={presenter.isOpened}
    />
  );
};

export default observer(FirstArticleOnboarding);
